import React from "react"
import { Dialog, FlatButton } from "material-ui"
import strings from "../../localization/strings"
import PayrollSelection from "./PayrollSelection"
import { IDate, IJobDocument, IUpdatePayrollSettings } from "../../models"
import moment from "moment"
import IconDatePicker from "../common/IconDatePicker"
import * as userActions from "../../actions/UserActions"
import AppStateStore from "../../stores/AppStateStore"

interface IProps {
    userId: string
    employeePayrollHierarchyItemId: string
    employeeDefaultJob: IJobDocument
    employeeDefaultPunchHierarchyItemId: string
    employeePayrollPayGroupId: string
    employeePayrollPayGroupManualSet: boolean
    employeeOTPolicyId: string
    employeeOTPolicyManualSet: boolean
    handleChange(payrollHierarchyId: string, payrollPayGroupId: string, payrollPayGroupManualSet: boolean, otPolicyId: string, otPolicyManualSet: boolean): void
    handleClose(): void
}
interface IState {
    effectiveDate: IDate
    employeePayrollHierarchyItemId: string
    employeePayrollPayGroupId: string
    employeePayrollPayGroupManualSet: boolean
    employeeOTPolicyId: string
    employeeOTPolicyManualSet: boolean
    employeeOTPolicyIdError: boolean
}

export default class EditPayrollSettingsDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            effectiveDate: moment(),
            employeePayrollHierarchyItemId: props.employeePayrollHierarchyItemId,
            employeePayrollPayGroupId: props.employeePayrollPayGroupId,
            employeePayrollPayGroupManualSet: props.employeePayrollPayGroupManualSet,
            employeeOTPolicyId: props.employeeOTPolicyId,
            employeeOTPolicyManualSet: props.employeeOTPolicyManualSet,
            employeeOTPolicyIdError: false
        }
    }

    updatePayrollSettings() {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_update_payroll_settings,
            confirm: () => {
                const updatePayrollSettings: IUpdatePayrollSettings = {
                    EffectiveDate: moment(this.state.effectiveDate).startOf("day").utc(true).format(),
                    PayrollHierarchyItemId: this.state.employeePayrollHierarchyItemId,
                    PayrollPayGroupId: this.state.employeePayrollPayGroupId,
                    PayrollPayGroupManualSet: this.state.employeePayrollPayGroupManualSet,
                    OTPolicyId: this.state.employeeOTPolicyId
                }
                this.props.handleChange(this.state.employeePayrollHierarchyItemId, this.state.employeePayrollPayGroupId, this.state.employeePayrollPayGroupManualSet, this.state.employeeOTPolicyId, this.state.employeePayrollPayGroupManualSet)
                this.props.handleClose()
                userActions.updatePayrollSettings(this.props.userId, updatePayrollSettings)
            }
        })
    }

    render() {
        return (
            <Dialog
                modal
                open
                title={strings.Edit_Payroll_Settings}
                actions={[
                    <FlatButton
                        data-intercom-target={"Btn-EditPayrollSettingsDialog-Close"}
                        label={strings.Close}
                        secondary
                        onTouchTap={this.props.handleClose}
                    />,
                    <FlatButton
                        data-intercom-target={"Btn-EditPayrollSettingsDialog-Save"}
                        label={strings.Save}
                        primary
                        disabled={this.state.employeeOTPolicyIdError ||
                            (
                                this.props.employeePayrollHierarchyItemId === this.state.employeePayrollHierarchyItemId &&
                                this.props.employeePayrollPayGroupId === this.state.employeePayrollPayGroupId &&
                                this.props.employeePayrollPayGroupManualSet === this.state.employeePayrollPayGroupManualSet &&
                                this.props.employeeOTPolicyId === this.state.employeeOTPolicyId
                            )
                        }
                        onClick={() => this.updatePayrollSettings()}
                    />
                ]}
                onRequestClose={this.props.handleClose}
            >
                <IconDatePicker
                    label="Effective Date"
                    date={this.state.effectiveDate}
                    handleSelectDate={date => this.setState({ effectiveDate: date })}
                    minDate={moment()}
                />
                <PayrollSelection
                    employeePayrollHierarchyItemId={this.state.employeePayrollHierarchyItemId}
                    employeeDefaultJob={this.props.employeeDefaultJob}
                    employeeDefaultPunchHierarchyItemId={this.props.employeeDefaultPunchHierarchyItemId}
                    employeePayrollPayGroupId={this.state.employeePayrollPayGroupId}
                    employeePayrollPayGroupManualSet={this.state.employeePayrollPayGroupManualSet}
                    employeeOTPolicyId={this.state.employeeOTPolicyId}
                    employeeOTPolicyManualSet={this.state.employeeOTPolicyManualSet}
                    handleChange={(payrollHierarchyItemId, payrollPayGroupId, payrollPayGroupManualSet, otPolicyId, otPolicyManualSet, otPolicyIdError) => {
                        this.setState({
                            employeePayrollHierarchyItemId: payrollHierarchyItemId,
                            employeePayrollPayGroupId: payrollPayGroupId,
                            employeePayrollPayGroupManualSet: payrollPayGroupManualSet,
                            employeeOTPolicyId: otPolicyId,
                            employeeOTPolicyManualSet: otPolicyManualSet,
                            employeeOTPolicyIdError: otPolicyIdError
                        })
                    }}
                    updateUserPayrollHierarchy
                    userId={this.props.userId}
                />
            </Dialog>
        )
    }
}